import { Anuncio } from "app/anuncio/models/anuncio.model";
import { AnuncioInteresseSituacaomEnum } from "../enum/anuncio-interesse-situacao.enum";

export function eInteresseCancelado(anuncio: Anuncio): boolean {
  if(anuncio.interesseSituacao && anuncio.interesseSituacao.id == AnuncioInteresseSituacaomEnum.CANCELADO){
    return true;
  }
  return false;
}

export function  formataNumeroParaMoeda(value: number| null): string {
  if(value === null || value === undefined){
    return 'R$ 0,00';
  }
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
